<template>
  <!-- PRD-022 — passos de instalação manual no iOS (Safari não tem prompt nativo).
       Presentacional, reusado pelo convite (InstallInvite) e pelo botão em
       Configurações (PwaInstallCard). -->
  <div class="info-card">
    <div class="info-card-header">
      <i class="fas fa-mobile-screen-button"></i>
      <span>Passos no Safari</span>
    </div>
    <div class="info-card-body">
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">
            <i class="fas fa-arrow-up-from-bracket"></i> 1. Toque em Compartilhar
          </span>
          <span class="info-value">Na barra inferior do Safari.</span>
        </div>
        <div class="info-item">
          <span class="info-label">
            <i class="fas fa-square-plus"></i> 2. Adicionar à Tela de Início
          </span>
          <span class="info-value">Role a lista de opções e selecione.</span>
        </div>
        <div class="info-item">
          <span class="info-label">
            <i class="fas fa-check"></i> 3. Confirme em Adicionar
          </span>
          <span class="info-value">O ícone do SD Admin vai pra sua tela inicial.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Sem lógica — só os passos. A decisão (Sim/Mais tarde/Não) fica no chamador.
</script>
